var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGraphBar = function SvgGraphBar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1995 1C15.0949 1 14.1995 1.89543 14.1995 3V6.00982C14.1339 6.00333 14.0673 6 14 6L9 6C7.89543 6 7 6.89543 7 8L7 12L3 12C1.89543 12 1 12.8954 1 14L1 22C1 22.5523 1.44772 23 2 23H8L15 23C15.0337 23 15.0669 22.9983 15.0997 22.9951C15.1325 22.9983 15.1658 23 15.1995 23H22C22.5523 23 23 22.5523 23 22L23 3C23 1.89543 22.1046 1 21 1L16.1995 1ZM16.1995 3L21 3L21 21H16.1995L16.1995 3ZM7 14L7 21H3L3 14L7 14ZM14 21L9 21L9 14V8L14 8L14 21Z",
    fill: "black"
  })));
};
export { SvgGraphBar as ReactComponent };
export default __webpack_public_path__ + "static/media/graph-bar.aa61da97.svg";